import { useEffect, useState } from "react";
import { UserCheck } from "lucide-react";
import { Header } from "@/pages/Operations";
import { AccessGate } from "@/components/AccessGate";
import { CharactersPanel } from "@/components/agent/CharactersPanel";
import api from "@/lib/api";

export default function Avatars() {
  const [workspaces, setWorkspaces] = useState([]);
  const [wsId, setWsId] = useState("");
  useEffect(() => { api.get("/workspaces").then((r) => setWorkspaces(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="avatars-page">
      <AccessGate />
      <Header icon={UserCheck} eyebrow="Avatar Studio · Characters & presenters" title="One identity. Every image, every video."
        subtitle="Create a persistent virtual character (reference portrait, voice, style, rules). Reuse it for reference-guided images and lip-synced talking presenter videos (OpenAI TTS + SadTalker via fal). Real people's likeness requires consent; no impersonation." />
      <div className="mb-4">
        <select data-testid="avatars-workspace-select" value={wsId} onChange={(e) => setWsId(e.target.value)} className="bg-black/30 border border-white/10 rounded-lg px-3 py-2 text-xs">
          <option value="">All workspaces</option>
          {workspaces.map((w) => <option key={w.workspace_id} value={w.workspace_id}>{w.name}</option>)}
        </select>
      </div>
      <CharactersPanel wsId={wsId} />
    </div>
  );
}
